export const environment = {
  production: true,
  name: 'sit',
  base_url: 'https://techrevampapi.flydocstest.com',
  lam_url: 'https://lam.flydocstest.com',
  drm_url: 'https://frontend.flydocstest.com',
  drm_base_url: 'https://techrevampapi.flydocstest.com',
};

export const environmentName: 'SIT' | 'UAT' | 'PROD' | 'PROD2' = 'SIT';

// Azure SSO configuration
export const AZURE_SSO_B2C_CONFIG = 'B2C_1A_FLYDOCSTEST_SIGNUP_SIGNIN';
export const AZURE_SSO_B2C_CONFIG_URL =
  'https://myflydocs.b2clogin.com/myflydocs.onmicrosoft.com/B2C_1A_FLYDOCSTEST_SIGNUP_SIGNIN';
export const AZURE_SSO_CLIENT_ID = '238e9751-c5e1-4606-bbf4-16e0a8d9d338';
export const AZURE_SSO_CLIENT_CLASSIC_URL = 'https://frontend.flydocstest.com/';
